export default __webpack_public_path__ + "static/media/560.e137b02f.png";